<template>
  <div class="change-password">
    <div class="container">
      <div class="flex justify-center">
        <div class="w-full max-w-md mx-auto">
          <div class="card">
            <div class="p-12">
              <div class="mb-6">
                <h1 class="mb-2 text-2xl font-bold">Set a new password</h1>
                <p class="text-gray-500">Enter a new password for your account.</p>
              </div>
              <form @submit.prevent="resetPassword()">
                <fieldset class="mt-4 form-group">
                  <label class="items-center justify-between form-label">
                    New Password 
                    <a class="text-xs font-medium tracking-wide uppercase text-primary hover:underline" href="#" @click="showPassword = !showPassword" tabindex="3">
                      {{ showPassword ? 'Hide' : 'Show' }} Password
                    </a>
                  </label>
                  <input id="password" :type="showPassword ? 'text' : 'password'" class="py-3 form-input" placeholder="Enter a new password" v-model="form.password" minlength="8">
                </fieldset>
                <button type="submit" class="w-full btn btn-lg btn-primary" v-submitting="submitting">
                  Save Password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResetPassword',

    metaInfo: {
      title: 'Reset Password'
    },

    data () {
      return {
        showPassword: false,
        submitting: false,
        form: {
          password: '',
          reset_password_token: this.$route.query.token
        }
      }
    },

    methods: {
      async resetPassword () {
        try {
          this.submitting = true
          await this.$api.post('auth/reset-password', this.form)
          this.$router.push({ name: 'Login' })
        } catch (error) {
          console.error(error)
          this.$toasted.error(error.response.data.message)
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>